
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"32","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 14"}},[_c('g',{staticClass:"layer"},[_c('path',{attrs:{"d":"M21 14H1a1 1 0 0 1 0-2h20a1 1 0 0 1 0 2zm0-6H1a1 1 0 0 1 0-2h20a1 1 0 0 1 0 2zm0-6H1a1 1 0 0 1 0-2h20a1 1 0 0 1 0 2z","fill":"#399E8B"}})])])
      }
    
      }
    